<form [formGroup]="activityStatusFilterForm" class="form-wrapper">
  <div [class.row-layout]="useRowLayout$ | async" class="filters">
    @if (displayStatusFilters$ | async) {
      <mat-form-field class="activity-status flex-fill" appearance="outline">
        <mat-select required formControlName="activityStatus" [panelWidth]="280">
          @for (showActivityStatus of (activityStatusesToShow$ | async); track showActivityStatus) {
            <mat-option [value]="showActivityStatus.value">
              {{ showActivityStatus.displayValue | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <mat-form-field class="flex-fill" appearance="outline">
      <mat-select required formControlName="showActivities" [panelWidth]="220">
        @for (option of organizationFilterOptions$ | async; track option) {
          <mat-option [value]="option.value">
            {{ option.displayValue }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="activity-sort flex-fill" appearance="outline">
      <mat-select [formControl]="sortOptionControl" [placeholder]="'activity_status_filters.sorting.placeholder' | translate">
        <mat-option [value]="">{{ 'activity_status_filters.sorting.none' | translate }}</mat-option>
        @for (sortOption of localSortingOptions; track sortOption) {
          <mat-option [value]="sortOption">
            {{ sortOption.displayValue | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</form>
